import CartOrderCard from './CartOrderCard';

export default CartOrderCard;
